import { Component, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

import { ChartOptions, ChartType } from 'chart.js';
import { Color, BaseChartDirective, Label } from 'ng2-charts';
import * as pluginAnnotations from 'chartjs-plugin-annotation';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  db = firebase.firestore();
  auth = firebase.auth();

  currentUser;
  from;
  to;
  title;
  ordersTotal;
  deliveredPercentage;
  ratedPercentage;
  rate;
  expiredPercentage;
  refusedPercentage;
  ordersAverage;
  billing;
  wastedBilling;

  clientsMostOrdered = {};
  clientsMostOrderedArray = [];

  loading = true;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  public monthDayChartData = [
    { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Pedidos' },
  ];
  public weekDayChartData = [
    { data: [0, 0, 0, 0, 0, 0, 0], label: 'Pedidos' },
  ];
  public billingMonthDayChartData = [
    { data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Faturamento' },
  ];
  public billingWeekDayChartData = [
    { data: [0, 0, 0, 0, 0, 0, 0], label: 'Faturamento' },
  ];
  public monthDayChartLabels: Label[] = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
  public weekDayChartLabels: Label[] = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo'];
  public chartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    scales: {
      xAxes: [{}],
      yAxes: [
        {
          id: 'y-axis-0',
          position: 'left',
          ticks: {
            beginAtZero: true
          }
        }
      ]
    },
    annotation: {
      annotations: [{
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: 'March',
        borderColor: 'black',
        borderWidth: 2,
        label: {
          enabled: true,
          fontColor: 'black',
          content: 'LineAnno'
        }
      }],
    },
  };
  public billingChartOptions: (ChartOptions & { annotation: any }) = {
    responsive: true,
    tooltips: {
      callbacks: {
        label: (item, data) => {
          return 'Faturamento: R$ ' + item.yLabel;
        }
      }
    },
    scales: {
      xAxes: [{}],
      yAxes: [
        {
          id: 'y-axis-0',
          position: 'left',
          ticks: {
            beginAtZero: true,
            callback: label => 'R$ ' + label
          }
        }
      ]
    },
    annotation: {
      annotations: [{
        type: 'line',
        mode: 'vertical',
        scaleID: 'x-axis-0',
        value: 'March',
        borderColor: 'black',
        borderWidth: 2,
        label: {
          enabled: true,
          fontColor: 'black',
          content: 'LineAnno'
        }
      }],
    },
  };
  public chartColors: Color[] = [{
    backgroundColor: 'rgba(184,71,61,0.2)',
    borderColor: 'rgba(184,71,61,1)',
    pointBackgroundColor: 'rgba(184,71,61,1)',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: 'rgba(184,71,61,0.8)'
  }];
  public billingChartColors: Color[] = [{
    backgroundColor: 'rgba(40,167,69,0.2)',
    borderColor: 'rgba(40,167,69,1)',
    pointBackgroundColor: 'rgba(40,167,69,1)',
    pointBorderColor: '#fff',
    pointHoverBackgroundColor: '#fff',
    pointHoverBorderColor: 'rgba(40,167,69,1)'
  }];
  public chartLegend = true;
  public chartType: ChartType = 'line';
  public chartPlugins = [pluginAnnotations];

  constructor() {
    this.from = moment().startOf('month').toISOString().split('T')[0];
    this.to = moment().toISOString().split('T')[0];
  }

  ngOnInit() {
    this.auth.onAuthStateChanged(authState => {
      this.currentUser = authState.uid;
      this.getReport();
    });
  }

  getReport() {
    this.loading = true;
    this.clientsMostOrdered = {};

    this.monthDayChartData = [{ data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Pedidos' }];
    this.weekDayChartData = [{ data: [0, 0, 0, 0, 0, 0, 0], label: 'Pedidos' }];
    this.billingMonthDayChartData = [{ data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], label: 'Faturamento' }];
    this.billingWeekDayChartData = [{ data: [0, 0, 0, 0, 0, 0, 0], label: 'Faturamento' }];

    this.db.collection('store').doc(this.currentUser).collection('orders')
    .where('moment', '>=', moment(this.from).startOf('day').toISOString())
    .where('moment', '<=', moment(this.to).endOf('day').toISOString())
    .get().then(orders => {
      this.loading = false;
      this.title = 'De ' + moment(this.from).format('DD/MM/YYYY') + ' até ' + moment(this.to).format('DD/MM/YYYY');
      this.ordersTotal = orders.docs.length;
      this.ordersAverage = (this.ordersTotal / moment(moment(this.to)).diff(moment(this.from), 'days')).toFixed(1);
      let delivered = 0;
      let rated = 0;
      let rateSum = 0;
      let expired = 0;
      let refused = 0;
      let billing = 0;
      let wastedBilling = 0;
      orders.docs.map(orderDb => {
        let order = orderDb.data();
        if (order.status == 'finished' || order.status == 'received') {
          delivered++
          billing += order.total;
        }
        if (order.status == 'expired' || order.status == 'refused') {
          wastedBilling += order.total;
        }
        if (order.rate > 0) {
          rateSum += order.rate;
          rated++
        }
        if (order.status == 'expired') expired++;
        if (order.status == 'refused') refused++;
        if (!this.clientsMostOrdered[order.clientId]) {
          this.clientsMostOrdered[order.clientId] = {
            qtd: 1,
            name: order.clientName
          }
        } else {
          this.clientsMostOrdered[order.clientId].qtd++;
        }
        this.weekDayChartData[0].data[moment(order.moment).isoWeekday()-1]++;
        this.monthDayChartData[0].data[moment(order.moment).date()-1]++;
        this.billingWeekDayChartData[0].data[moment(order.moment).isoWeekday()-1] += order.total;
        this.billingMonthDayChartData[0].data[moment(order.moment).date()-1] += order.total;
      });
      
      this.clientsMostOrderedArray = Object.values(this.clientsMostOrdered).sort(this.compare).slice(0, 5);
      this.deliveredPercentage = (100 * delivered / orders.docs.length).toFixed(1);
      this.ratedPercentage = (100 * rated / delivered).toFixed(1);
      this.expiredPercentage = (100 * expired / orders.docs.length).toFixed(1);
      this.refusedPercentage = (100 * refused / orders.docs.length).toFixed(1);
      this.rate = (rateSum / rated).toFixed(2);
      this.billing = billing.toFixed(2);        
      this.wastedBilling = wastedBilling.toFixed(2);          
    });
  }

  compare(a, b) {
    if (a.qtd > b.qtd ){
      return -1;
    }
    if (a.qtd < b.qtd){
      return 1;
    }
    return 0;
  }

}
